export class BusinessInfo {
	dbaName = "";
	website = "";
	websiteInformation = null;
	phone = "";
	typeOfBusiness = "";
	legalName = "";
	fax = "";
	csPhone = "";
	customerServiceEmail = "";
	taxId = "";
	// TODO: Remove after Geolocation flag is removed
	businessAddress = {
		address_line1: "",
		address_line2: "",
		city: "",
		region_code: "",
		postal_code: "",
		type_of_location: "",
		location_if_other: "",
	};
	legalAddress = {
		isLegalAddressTheSame: "true",
		address_line1: "",
		address_line2: "",
		city: "",
		region_code: "",
		postal_code: "",
	};
	swiped = "";
	keyed = "";
	eCommerce = "";
	refundPolicy = "RefundWithin30Days";
	creditAndDebitCardTransactionsAreSettled = "DateOfOrder";
	sellingOutsideOfUS = "false";
	haveYouAcceptedCardsPreviously = "true";
	whoWasPreviousProcessor = "";
	hasAProcessorEverTerminatedYourMerchantAccount = "false";
	ifSoWhoWasThatProcessor = "";
	minDaysToDelivery = "";
	avgDaysToDelivery = "";
	maxDaysToDelivery = "";
	recurringPayments = "false";
	doYouUseAThirdPartyForFulfillment = "false";
	whoDoYouUseAThirdPartyForFulfillment = "";
	siteInspectionBy = "aurora";
	merchantType = "new";
	ifMotoECommerceWhoDoesFulfillment = "Merchant";
	hasMerchbennPrevIdentifiedByVisaMCRiskProgram = "false";
	merchPrincipalOwnerBankruptcy = "false";
	ifYesDateField = "";
	doYouUseIntegratedSoftwareToProcessPayments = "false";
	routing = "";
	bank = "";
	account = "";
	accountName = "";
	creditDebitCardTransactionsAreSettledTypeIfOther = "";
	previousAccountMIDNumber = "";
	monthlyAMEX = "";
	monthlyVMCD = "";
	avgTicketAMEX = "";
	avgTicketVMCD = "";
	highTicketAMEX = "";
	highTicketVMCD = "";
	documentationMailingAddress = "legal_address";
	isPrintingPaperStatementEnabled = "false";
}
